import React from "react"

import { styled } from "@mui/material/styles"

import { transformTitle } from "./helpers/transformTitle"
import { IAvatar } from "./types/Avatar"
import { Tooltip } from "../Tooltip"

export const Avatar = ({ title, tooltip, active = false, picUrl, size = null, ...props }: IAvatar) =>
  <StyledTooltip
    title={props.tooltipDisabled
      ? ""
      : (tooltip || title)}>

    <StyledAvatar sx={{
      backgroundImage: picUrl ? `url(${picUrl})` : "initial",
      width: size ? `${size}px` : "34px",
      height: size ? `${size}px` : "34px",
      ...props.sx,
    }}
      className={active ? "active" : ""}>
      {picUrl ? "" : transformTitle(title)}
    </StyledAvatar>
  </StyledTooltip>

const StyledTooltip = styled(Tooltip)({
  height: "fit-content"
})

const StyledAvatar = styled("div")({
  borderRadius: "50%",
  fontSize: "13px",
  fontWeight: 600,
  border: "2px solid #fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#CCCCCC",
  color: "#1A1A1A",
  cursor: "pointer",
  backgroundSize: "cover",
  backgroundPosition: "center",

  "&.active": {
    border: "2px solid #008859"
  }
})

